import mime from 'mime';
export function getContentType(url) {
    return fetch(url, { method: 'HEAD' })
        .then(res => {
        const contentType = res.headers.get('content-type');
        if (!contentType) {
            return Promise.reject(new Error('No mime type!'));
        }
        return contentType;
    });
}
export function getExtension(contentType) {
    if (contentType === 'font/sfnt') {
        return 'ttf';
    }
    return mime.getExtension(contentType);
}
